import { Document, Font, Page } from '@react-pdf/renderer'

import mntsrtBold from '../../assets/fonts/Montserrat-Bold.ttf'
import mntsrtRegular from '../../assets/fonts/Montserrat-Regular.ttf'
import Header from './Header'
import CarInfo from './CarInfo'
import Damage from './Damage'

Font.register({
  family: 'Montserrat',
  fonts: [
    {
      src: mntsrtRegular
    },
    {
      src: mntsrtBold,
      fontWeight: 'bold'
    }
  ]
})

const InspectionReport = ({ techState, selectedCar, damagedParts }) => {
  return (
    <Document>
      <Page
        style={{
          margin: 0,
          padding: 0,
          fontFamily: 'Montserrat',
          color: '#000',
          position: 'relative'
        }}
      >
        <Header />
        <CarInfo techState={techState} selectedCar={selectedCar} />
        <Damage damagedParts={damagedParts} />
      </Page>
    </Document>
  )
}

export default InspectionReport
